import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "../GameList.module.css";
interface GameLoaderProps {
  cols: number; // Number of squares in each row
  rows: number; // Number of rows
  gap: number; // Gap between squares
}

const GameLoader: React.FC<GameLoaderProps> = ({ cols, rows, gap }) => {
  const maskSquares = Array.from({ length: cols * rows }, (_, index) => index); // Create squares based on rows * columns

  const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
  const containerRef = useRef<SVGSVGElement>(null);
  useEffect(() => {
    const resizeObserver = new ResizeObserver((entries) => {
      if (entries[0]?.contentRect) {
        setContainerSize({
          width: entries[0].contentRect.width,
          height: entries[0].contentRect.height,
        });
      }
    });

    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, []);

  // Compute dynamic square sizes
  const rectSize = useMemo(
    () => (containerSize.width > 0 ? (containerSize.width - gap * (cols - 1)) / cols : 0),
    [containerSize, cols, gap],
  );

  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="absolute h-full w-full"
        ref={containerRef}
      >
        <defs>
          {/* Mask with n Squares */}
          <mask id="maskSquares">
            {maskSquares.map((_, index) => {
              const row = Math.floor(index / cols);
              const col = index % cols;

              // Calculate the x and y positions for each rectangle with the gap applied
              const xPosition = `calc((100% - ${gap * (cols - 1)}px) / ${cols} * ${col} + ${col * gap}px)`; // Correct x position with the gap
              const yPosition = `calc((100% - ${gap * (rows - 1)}px) / ${rows} * ${row} + ${row * gap}px)`; // Correct y position with the gap

              return (
                <rect
                  key={index}
                  x={xPosition}
                  y={yPosition}
                  width={rectSize}
                  height={rectSize}
                  rx="6"
                  ry="6"
                  fill="white"
                />
              );
            })}
          </mask>
        </defs>
      </svg>
      <div className={styles.loadingSkeleton} />
    </>
  );
};

export default GameLoader;
